<template>
  <div class="ml-2">
    <working-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="siteContentObserver">
          <h3>STEP1 セラピストの「ご案内状況」 更新設定</h3>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="site_content_config.update_setting_s1"
                  :label="`${
                    site_content_config.update_setting_s1
                      ? '各セラピストのご案内状況を更新する'
                      : '各セラピストのご案内状況を更新する'
                  }`"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
          <h3 class="mt-8">STEP2 ご案内状況のボタン 時間帯別の更新設定</h3>
          <div class="mb-2">時間帯毎にどのボタンを押すか設定します。</div>
          <v-container fluid>
            <v-row
              v-for="(item, index) in update_setting_s2_hours"
              :key="index"
              class="d-flex align-center"
            >
              <v-col cols="2" sm="1" md="1" class="text-subtitle-1 text-end"
                >{{ item.value }}時</v-col
              >
              <v-col cols="10" sm="11" md="11">
                <v-btn-toggle
                  v-model="site_content_config[`update_setting_s2`][item.value]"
                  dense
                  mandatory
                  borderless
                  color="primary"
                >
                  <v-btn
                    v-for="(button, buttonIndex) in update_setting_s2_buttons"
                    :key="buttonIndex"
                    :value="button.value"
                  >
                    {{ button.text }}
                  </v-btn>
                </v-btn-toggle>
              </v-col>
            </v-row>
          </v-container>
          <h3 class="mt-8">STEP3 出勤表の「完売」 更新設定</h3>
          <div class="mb-2">
            「受付終了」に変更した時、出勤表の当日「完売」ボタンを押す（STEP1がONのときだけ指定可能）
          </div>
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-switch
                  v-model="site_content_config.update_setting_s3"
                  :disabled="!site_content_config.update_setting_s1"
                  :label="`${
                    site_content_config.update_setting_s3 ? 'ON' : 'OFF'
                  }`"
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </template>
    </working-site-card>
  </div>
</template>

<script>
import { set, reactive, toRefs, defineComponent } from "@vue/composition-api";
import setting from "@/common/setting.js";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const state = reactive({
      site_content_config: {},
      items: [],
    });

    const update_setting_s2_hours = [
      { value: 6, text: "6時" },
      { value: 7, text: "7時" },
      { value: 8, text: "8時" },
      { value: 9, text: "9時" },
      { value: 10, text: "10時" },
      { value: 11, text: "11時" },
      { value: 12, text: "12時" },
      { value: 13, text: "13時" },
      { value: 14, text: "14時" },
      { value: 15, text: "15時" },
      { value: 16, text: "16時" },
      { value: 17, text: "17時" },
      { value: 18, text: "18時" },
      { value: 19, text: "19時" },
      { value: 20, text: "20時" },
      { value: 21, text: "21時" },
      { value: 22, text: "22時" },
      { value: 23, text: "23時" },
      { value: 0, text: "0時" },
      { value: 1, text: "1時" },
      { value: 2, text: "2時" },
      { value: 3, text: "3時" },
      { value: 4, text: "4時" },
      { value: 5, text: "5時" },
    ];

    const update_setting_s2_buttons = [
      { value: 1, text: "◎今すぐご案内可" },
      { value: 2, text: "○多少空きあり" },
      { value: 3, text: "△残りわずか" },
    ];

    const init = async () => {
      // 個別項目の設定を取得
      state.items = setting.working_status_config.find(
        (item) => item.site_content_id === props.com_data.site_content_id
      ).items;

      // state.site_content_configにキーを設定
      for (let key in state.items) {
        set(state.site_content_config, key, null);
      }
      if (props.com_data.site_content_config) {
        Object.keys(props.com_data.site_content_config).forEach(function (key) {
          set(
            state.site_content_config,
            key,
            props.com_data.site_content_config[key]
          );
        });
      }
      // 初期値を設定する
      if (state.site_content_config["update_setting_s1"] == null) {
        set(state.site_content_config, "update_setting_s1", true);
      }
      if (state.site_content_config["update_setting_s2"] == null) {
        const item = {};
        for (let hour of update_setting_s2_hours) {
          set(item, hour.value, 1);
        }
        for (let hour of update_setting_s2_hours) {
          set(state.site_content_config, `update_setting_s2`, item);
        }
      }
      if (state.site_content_config["update_setting_s3"] == null) {
        set(state.site_content_config, "update_setting_s3", false);
      }
      // console.log(state.site_content_config);
    };

    init();

    // チェック処理
    const checkValid = async () => {
      // 事前チェック処理
      return await ctx.refs.siteContentObserver.validate();
    };

    const getConfig = async () => {
      return state.site_content_config;
    };

    return {
      props,
      setting,
      update_setting_s2_hours,
      update_setting_s2_buttons,
      ...toRefs(state),
      checkValid,
      getConfig,
    };
  },
});
</script>

<style scoped></style>
